module.exports = __webpack_public_path__ + "static/media/muzaffarpur6-10.adbb1714.jpeg";